import {Component} from "react";
import cookie from "react-cookies";

class Leftmenu extends Component {
  constructor(props) {
    super(props);
    var userid = cookie.load('userId');
    var userlist = cookie.load('userList');
    console.log(userlist)
    this.state = {
      userid: userid,
      userlist: userlist,
    };
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

  }

  render() {

    return (

        <div className="leftpanel">

          <div className="logopanel">
            <a href="/">
              <h1>陕西华山营销<span>智慧粉煤灰</span></h1>
            </a>
          </div>

          <div className="leftpanelinner">


            <h5 className="sidebartitle"> </h5>
            <ul className="nav nav-pills nav-stacked nav-bracket">

              {this.state.userlist.levelid == 1 || this.state.userlist.levelid == 2 || this.state.userlist.levelid == 3 || this.state.userlist.levelid == 4 || this.state.userlist.levelid == 5
                  ?
              <li className="nav-parent">
                <input id="ac-6" type="checkbox"/><a><label htmlFor="ac-6"><span>数据报表</span><i
                  className="iconfont icon-under"></i></label></a>
                <ul className="children">
                  <li><a href="/pagedataform">销售日报</a></li>
                </ul>
                <ul className="children">
                  <li><a href="/pagedataformclient">销售月报</a></li>
                </ul>
                <ul className="children">
                  <li><a href="/pagedataformyear">销售年报</a></li>
                </ul>
                <ul className="children">
                  <li><a href="/pagedataorder">订单查询</a></li>
                </ul>
              </li>
                  :
                  ''
              }
              {/*
              <ul className="children">
                <li><a href="/pagedatastate">销售报表</a></li>
              </ul>
              <ul className="children">
                <li><a href="/pagebusorders">流水管理</a></li>
              </ul>
              <ul className="children">
                <li><a href="/pagebusplan">发运计划</a></li>
              </ul>
              <ul className="children">
                <li><a href="/pagepurorders">订单信息</a></li>
              </ul>
              <ul className="children">
                <li><a href="/pagepurprices">资金管理</a></li>
              </ul>
              <ul className="children">
                <li><a href="/pagefinorders">订单审核</a></li>
              </ul>
              <ul className="children">
                <li><a href="/pagefinloans">贷款回收</a></li>
              </ul>
              <ul className="children">
                <li><a href="/pagefinbills">发票管理</a></li>
              </ul>
              <ul className="children">
                <li><a href="/pageselltask">任务管理</a></li>
              </ul>*/}
              {/*
            <li className="nav-parent">
              <input id="ac-1" type="checkbox"/><a><label htmlFor="ac-1"><span>数据中心</span><i
                className="iconfont icon-under"></i></label></a>
              <ul className="children">
                <li><a href="/pagedatastate">销售报表</a></li>
              </ul>
              <ul className="children">
                <li><a href="/pagedataserch">数据查询</a></li>
              </ul>
              <ul className="children">
                <li><a href="/pagedatacurve">销量曲线</a></li>
              </ul>
              <ul className="children">
                <li><a href="/pagedatacompare">销售对比</a></li>
              </ul>
              <ul className="children">
                <li><a href="/pagedataclient">客户对比</a></li>
              </ul>
              <ul className="children">
                <li><a href="/pagedatacapital">资金分析</a></li>
              </ul>
              <ul className="children">
                <li><a href="/pagedataorder">订单查询</a></li>
              </ul>
            </li>*/}

              {this.state.userlist.levelid == 1 || this.state.userlist.levelid == 2 || this.state.userlist.levelid == 3
                  ?
              <li className="nav-parent">
                <input id="ac-3" type="checkbox"/><a><label htmlFor="ac-3"><span>采购中心</span><i
                  className="iconfont icon-under"></i></label></a>
                <ul className="children">
                  <li><a href="/pagepurdemand">需求提报</a></li>
                </ul>
                <ul className="children">
                  <li><a href="/pagepurpicks">预提货单</a></li>
                </ul>
                <ul className="children">
                  <li><a href="/pagepurpickeds">提货单据</a></li>
                </ul>
                <ul className="children">
                  <li><a href="/pagepurinvs">库存管理</a></li>
                </ul>
              </li>
              :
              ''
              }

              {this.state.userlist.levelid == 1 || this.state.userlist.levelid == 2 || this.state.userlist.levelid == 4
                  ?
              <li className="nav-parent">
                <input id="ac-4" type="checkbox"/><a><label htmlFor="ac-4"><span>业务中心</span><i
                  className="iconfont icon-under"></i></label></a>
                <ul className="children">
                  <li><a href="/pagebusrecords">客户档案</a></li>
                </ul>
                <ul className="children">
                  <li><a href="/pagepurrecords">客户账号</a></li>
                </ul>
                <ul className="children">
                  <li><a href="/pagesellcars">客户车辆</a></li>
                </ul>
                <ul className="children">
                  <li><a href="/pagebuscontracts">合同管理</a></li>
                </ul>
                <ul className="children">
                  <li><a href="/pagebuildassay">化验报告</a></li>
                </ul>
              </li>
              :
              ''
              }
              {this.state.userlist.levelid == 1 || this.state.userlist.levelid == 2 || this.state.userlist.levelid == 3
                  ?
              <li className="nav-parent">
                <input id="ac-5" type="checkbox"/><a><label htmlFor="ac-5"><span>财务管理</span><i
                  className="iconfont icon-under"></i></label></a>
                <ul className="children">
                  <li><a href="/pagefinfunds">资金管理</a></li>
                </ul>
                <ul className="children">
                  <li><a href="/pagefincontracts">合同审核</a></li>
                </ul>
                <ul className="children">
                  <li><a href="/pagefincredits">信用管理</a></li>
                </ul>
                <ul className="children">
                  <li><a href="/pagefinsets">财务扎账</a></li>
                </ul>
                <ul className="children">
                  <li><a href="/pagefinsetshis">扎账历史</a></li>
                </ul>
                <ul className="children">
                  <li><a href="/pagefinchecks">客户对账单</a></li>
                </ul>
              </li>
                  :
                  ''
              }

              {this.state.userlist.levelid == 1
                  ?

                  <li className="nav-parent">
                    <input id="ac-2" type="checkbox"/><a><label htmlFor="ac-2"><span>系统管理</span><i
                      className="iconfont icon-under"></i></label></a>
                    <ul className="children">
                      <li><a href="/pagesellstocks">产品类型</a></li>
                    </ul>
                    <ul className="children">
                      <li><a href="/pagesellareas">区域管理</a></li>
                    </ul>
                    <ul className="children">
                      <li><a href="/pagesellmans">销售管理</a></li>
                    </ul>
                    <ul className="children">
                      <li><a href="/pagepurclause">合同条款</a></li>
                    </ul>
                    <ul className="children">
                      <li><a href="/pagesellsys">账号管理</a></li>
                    </ul>
                  </li>
                  :
                  ''
              }
            </ul>

            <div className="infosummary">
              <ul>
              </ul>
            </div>


          </div>

        </div>

    );
  }
}

export default Leftmenu;
